function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.5",
  d: "M13 16.328V13.5a1.5 1.5 0 00-1.5-1.5H8.672a1.5 1.5 0 00-1.06.44L4.438 15.61A1.5 1.5 0 004 16.671c0 .399.158.78.44 1.061l2.828 2.829a1.5 1.5 0 002.121 0l3.172-3.172a1.5 1.5 0 00.439-1.06v0z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.5",
  d: "M4 11V8a1 1 0 011-1h14a1 1 0 011 1v11a2 2 0 01-2 2h-5M8.5 7V5.5A3.5 3.5 0 0112 2v0a3.5 3.5 0 013.5 3.5V7"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.5",
  d: "M10 15h0m-.001 0l.001.001.001-.001"
}));